export const TERMS_LIST = [
  {
    title: "Acceptance",
    label:
      "The PO constitutes Buyer’s offer to purchase goods or services described therein. Seller’s acknowledgment, commencement of work, or shipment of goods shall constitute acceptance of these Terms. Any additional or conflicting terms proposed by Seller are rejected unless expressly accepted in writing by Buyer.",
  },
  {
    title: "Price & Payment",
    label:
      "Prices stated on the PO are firm and not subject to increase without Buyer’s written consent. Unless otherwise agreed, payment terms are Net 30 days from receipt of a correct invoice and acceptance of goods/services. All invoices must reference the PO number.",
  },
  {
    title: "Delivery & Title",
    label:
      "Delivery must be made in accordance with the schedule, specifications, and instructions stated on the PO. Time is of the essence. Buyer reserves the right to cancel or reject shipments made later than the required date. Title and risk of loss shall pass to Buyer upon delivery at the location designated in the PO.",
  },
  {
    title: "Packaging & Shipping",
    label:
      "All goods must be properly packed, marked, and shipped to ensure safe delivery and compliance with applicable laws. Buyer’s PO number must appear on all packing slips, labels, and invoices. Extra charges for packaging, boxing, or cartage will not be allowed unless specifically authorized in writing.",
  },
  {
    title: "Inspection & Rejection",
    label:
      "All goods and services are subject to Buyer’s inspection and approval. Buyer may reject any goods/services that are defective, non-conforming, or fail to meet specifications. Rejected goods shall be returned at Seller’s expense, and Buyer may, at its option, require replacement, refund, or credit.",
  },
  {
    title: "Warranties",
    label:
      "Seller expressly warrants that all goods will be new, free from defects, and conform to specifications. All goods will be merchantable, of good material and workmanship, and fit for their intended purpose. All services will be performed in a professional and workmanlike manner.",
  },
  {
    title: "Compliance with Laws",
    label:
      "Seller shall comply with all applicable federal, state, and local laws, including OSHA, EPA, hazardous material regulations, and import/export laws. Seller shall indemnify Buyer for any losses resulting from non-compliance.",
  },
  {
    title: "Quality & Documentation",
    label:
      "Seller shall provide all necessary certifications, test reports, or documentation required by the PO or industry standards. All chemicals must be accompanied by current Safety Data Sheets (SDS). Buyer reserves the right to audit Seller’s quality systems.",
  },
  {
    title: "Changes",
    label:
      "Buyer may make changes to specifications, quantities, delivery schedules, or other aspects of the PO by written notice. If such changes affect cost or delivery, Seller must notify Buyer in writing within 3 business days for adjustment.",
  },
  {
    title: "Termination",
    label:
      "Buyer may cancel the PO without liability if Seller fails to perform, breaches these Terms, or becomes insolvent. Buyer may also terminate for convenience with written notice, compensating Seller only for goods/services provided up to termination.",
  },
  {
    title: "Indemnification",
    label:
      "Seller shall indemnify, defend, and hold Buyer harmless from any claims, damages, losses, liabilities, costs, or expenses (including attorney’s fees) arising out of or related to Seller’s goods or services, including defects, non-compliance, intellectual property infringement, or injury caused by the goods.",
  },
  {
    title: "Insurance",
    label:
      "Seller shall maintain adequate insurance coverage, including general liability, workers’ compensation, and product liability insurance, in commercially reasonable amounts. Certificates of insurance shall be provided upon request.",
  },
  {
    title: "Force Majeure",
    label:
      "Neither party shall be liable for failure to perform due to causes beyond their reasonable control, including acts of God, strikes, war, government actions, or natural disasters. Seller must promptly notify Buyer of any such event that may delay performance.",
  },
  {
    title: "Confidentiality & Intellectual Property",
    label:
      "All drawings, patterns, designs, specifications, and technical information provided by Buyer are Buyer’s property and must be kept confidential, not disclosed to third parties, and used solely to fulfill Buyer’s orders. Tooling, patterns, or designs paid for by Buyer shall remain Buyer’s property unless otherwise agreed in writing.",
  },
  {
    title: "Flow-Down Requirements & Counterfeit Prevention",
    label:
      "When applicable to the PO, Seller shall comply with all customer flow-down requirements. Seller shall ensure material traceability, provide certifications when applicable, and prevent use of counterfeit or substitute materials without Buyer’s approval.",
  },
  {
    title: "Governing Law & Venue",
    label:
      "This PO shall be governed by and construed in accordance with the laws of the state where the Buyer's facility designated on the PO is located, without regard to conflict of law principles. Any disputes shall be resolved exclusively in the state or federal courts located within the Governing State.",
  },
  {
    title: "Entire Agreement & Severability",
    label:
      "This PO and these Terms constitute the entire agreement between the parties regarding the subject matter. If any provision is held invalid or unenforceable, the remaining provisions shall remain in full force and effect.",
  },
];
